import api from "../../api";
import { initLectureState } from "./lecture.inits";

import { category } from "./category";
import { chat } from "./chat/chat.store";

/** @type {(import("vuex").Module<import("./lecture.inits").LectureState>)} */
export const lecture = {
    namespaced: true,

    state: initLectureState(),

    getters: {
        isUserCompany(state, getters, rootState, rottGetters) {
            return state.lecture?._company == rottGetters?._user;
        },
    },

    mutations: {
        setLectureIndex(state, { _lecture }) {
            state._lecture = _lecture;
        },
        setLecture(state, { lecture }) {
            state.lecture = lecture;
        },

        setIsAccessible(state, { isAccessible }) {
            state.isAccessible = isAccessible;
        },

        reset(state) {
            state._lecture = undefined;
            state.lecture = undefined;
            state.isAccessible = undefined;
        },
    },

    actions: {
        async getLecture({ state, commit }, { code } = {}) {
            let props = { _id: state._lecture, params: { code } };
            if (!props.params.code) delete props.params.code;

            const { lecture, isAccessible } = await api.v1.lectures.get(props);

            commit("setLecture", { lecture });
            commit("setIsAccessible", { isAccessible });
        },
    },

    modules: {
        category,
        chat,
    },
};
